import { Branch, Commit, Repository } from '@basehub/data/replicache/index'
import { PublicRepo } from '@basehub/data/replicache/mutators/_public-types'

export const branchIsMerged = ({
  ahead,
  merges,
}: {
  ahead: number
  merges: Commit[]
}) => {
  return ahead === 0 && merges.length > 0
}

export const getProviderBranchUrl = ({
  repo,
  branch,
}: {
  repo: PublicRepo | Repository | undefined
  branch: Branch
}) => {
  const shouldAddSlash = !repo?.gitRepoUrl?.endsWith('/')

  return repo?.gitRepoUrl && branch.git?.branch
    ? `${repo?.gitRepoUrl}${shouldAddSlash ? '/' : ''}tree/${encodeURIComponent(
        branch.git?.branch ?? ''
      )}`
    : ''
}
